import React from "react";
import "./Template3.css";

function Template3({answer}) {
  return (
    <div className="template3">
      <div className="answer-box">
        <div className="quote-icon">"</div>
        <p className="answer-text">{answer}</p>
      </div>
    </div>
  );
}

export default Template3;
